export { STATE_NAME } from './constants';
export { default as reducer } from './reducer';
import SavedSearches from './containers/SavedSearches';

export default SavedSearches;
